import type { StripeBillingConfig } from './stripeBillingService';

export function createStripeConfigCache(load: () => Promise<StripeBillingConfig>): {
  get: () => Promise<StripeBillingConfig>;
  clear: () => void;
} {
  let inflight: Promise<StripeBillingConfig> | null = null;
  return {
    clear(): void {
      inflight = null;
    },
    get(): Promise<StripeBillingConfig> {
      if (!inflight) {
        inflight = load().catch((err: unknown) => {
          inflight = null;
          throw err;
        });
      }
      return inflight;
    },
  };
}
